import request from '@/utils/requests.js'

// Technician API Services
export const technicianService = {
  // Dashboard metrics
  getDashboardMetrics() {
    return request({
      url: '/technician/metrics',
      method: 'get'
    });
  },

  // Dashboard metrics by period
  getMetricsByPeriod(period = '7d') {
    return request({
      url: '/technician/metrics',
      method: 'get',
      params: { period }
    });
  },

  // Equipment management
  getEquipmentStatus() {
    return request({
      url: '/technician/equipment/status',
      method: 'get'
    });
  },

  updateEquipmentStatus(equipmentId, status) {
    return request({
      url: `/technician/equipment/${equipmentId}/status`,
      method: 'put',
      data: { status }
    });
  },

  // Exam scheduling
  getTodaySchedule() {
    return request({
      url: '/technician/schedule/today',
      method: 'get'
    });
  },

  startExam(examId) {
    return request({
      url: `/technician/exams/${examId}/start`,
      method: 'post'
    });
  },

  // Upload stats
  getUploadStats() {
    return request({
      url: '/technician/uploads/stats',
      method: 'get'
    });
  },

  // Alerts and maintenance
  getSystemAlerts() {
    return request({
      url: '/technician/alerts',
      method: 'get'
    });
  },

  getMaintenanceSchedule() {
    return request({
      url: '/technician/maintenance',
      method: 'get'
    });
  },

  reportIssue(equipmentId, description) {
    return request({
      url: '/technician/issues/report',
      method: 'post',
      data: { equipmentId, description }
    });
  },

  // DICOM Upload
  async uploadDicom(file, examId = null) {
    const formData = new FormData()
    formData.append('dicom_file', file)
    if (examId) {
      formData.append('exam_id', examId)
    }

    return request({
      url: '/technician/upload-dicom',
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  // Patient Management for Technicians
  async createPatient(patientData) {
    return request({
      url: '/technician/patients',
      method: 'post',
      data: patientData
    })
  },

  // Exam Management for Technicians
  async createExam(examData) {
    return request({
      url: '/technician/exams',
      method: 'post',
      data: examData
    })
  },

  async listExams(params = {}) {
    return request({
      url: '/technician/exams',
      method: 'get',
      params
    })
  },

  async getExamById(examId) {
    return request({
      url: `/technician/exams/${examId}`,
      method: 'get'
    })
  }
}
